import { type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/cn';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium',
  {
    variants: {
      variant: {
        default: 'bg-[var(--color-border)] text-[var(--color-text)]',
        primary: 'bg-[var(--color-primary)]/10 text-[var(--color-primary)]',
        rise: 'bg-[var(--color-rise)]/10 text-[var(--color-rise)]',
        fall: 'bg-[var(--color-fall)]/10 text-[var(--color-fall)]',
        editor: 'bg-amber-500/10 text-amber-600',
        premium: 'bg-gradient-to-r from-amber-400 to-orange-500 text-white',
        outline: 'border border-[var(--color-border)] text-[var(--color-text)]',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
